import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

const REGISTER_ENDPOINT = {
  REGISTER_STUDENT: "/registration",
  INTERVIEW_LIST: "/registration/interview-list",
  ALL_REGISTRATIONS: "/registration",
  UPDATE_REGISTRATION: "/registration",
  DELETE_REGISTRATION: "/registration",
  SCHEDULE_TEST_INTERVIEW: "/registration/interview-schedule",
  UPDATE_REGISTRATION_STATUS: "/registration/test-status",
  UPDATE_INTERVIEW_STATUS: "/registration/interview-status",
}

const newRegistration = async (data: any) => {
  const response = await apiClient({
    url: REGISTER_ENDPOINT.REGISTER_STUDENT,
    method: "POST",
    data,
  })
  return response.data
}

const updateRegistration = async (_id: string, data: any) => {
  const response = await apiClient({
    url: `${REGISTER_ENDPOINT.UPDATE_REGISTRATION}/${_id}`,
    method: "PUT",
    data,
  })
  return response.data
}

const deleteRegistration = async (_id: string) => {
  const response = await apiClient({
    url: `${REGISTER_ENDPOINT.DELETE_REGISTRATION}/${_id}`,
    method: "DELETE",
  })
  return response.data
}

const getAllRegistration = async ({
  page = 1,
  limit = 10,
  searchText: search,
  class: appliedClass,
  status,
  gender,
  startDate,
  endDate,
  sortBy,
  sortOrder,
  testGroup,
  testStatus,
  system,
  session,
  source,
  includeAdmitted,
}: {
  page: number
  limit?: number
  searchText?: string
  class?: string
  status?: string
  gender?: string
  startDate?: string
  endDate?: string
  sortBy?: string
  sortOrder?: string
  testGroup?: string
  testStatus?: string
  system?: string
  session?: string
  source?: string
  // Default excludes already-admitted candidates (a work-queue view). Pass
  // true where the point is "who has ever used this" rather than "who still
  // needs action" — e.g. Test Group Registrations, which needs to include
  // candidates who've since been admitted to correctly reflect capacity.
  includeAdmitted?: boolean
}) => {
  const response = await apiClient({
    url: appendQueryParams(REGISTER_ENDPOINT.ALL_REGISTRATIONS, {
      page,
      limit,
      searchText: search,
      class: appliedClass,
      status,
      gender,
      startDate,
      endDate,
      sortBy,
      sortOrder,
      testGroup,
      testStatus,
      system,
      session,
      source,
      includeAdmitted,
    }),
    method: "GET",
  })
  return response.data
}

const getInterviewList = async ({
  page = 1,
  limit = 10,
  searchText: search,
  class: appliedClass,
  status,
  gender,
  startDate,
  endDate,
  sortBy,
  sortOrder,
  testGroup,
  testStatus,
  system,
  session,
}: {
  page: number
  limit?: number
  searchText?: string
  class?: string
  status?: string
  gender?: string
  startDate?: string
  endDate?: string
  sortBy?: string
  sortOrder?: string
  testGroup?: string
  testStatus?: string
  system?: string
  session?: string
}) => {
  const response = await apiClient({
    url: appendQueryParams(REGISTER_ENDPOINT.INTERVIEW_LIST, {
      page,
      limit,
      searchText: search,
      class: appliedClass,
      status,
      gender,
      startDate,
      endDate,
      sortBy,
      sortOrder,
      testGroup,
      testStatus,
      system,
      session,
    }),
    method: "GET",
  })
  return response.data
}

const scheduleInterview = async (
  registrationId: string,
  data: { interviewDate: string; interviewTime: string }
) => {
  const response = await apiClient({
    url: `${REGISTER_ENDPOINT.SCHEDULE_TEST_INTERVIEW}/${registrationId}`,
    method: "PUT",
    data: {
      interviewDate: data.interviewDate,
      interviewTime: data.interviewTime,
    },
  })
  return response.data
}

const updateInterviewStatus = async (
  registrationId: string,
  status: "passed" | "failed"
) => {
  const response = await apiClient({
    url: `${REGISTER_ENDPOINT.UPDATE_INTERVIEW_STATUS}/${registrationId}`,
    method: "PUT",
    data: {
      interviewStatus: status,
    },
  })
  return response.data
}

const updateRegistrationStatus = async (
  registrationId: string,
  status: "passed" | "failed"
) => {
  const response = await apiClient({
    url: `${REGISTER_ENDPOINT.UPDATE_REGISTRATION_STATUS}/${registrationId}`, // Matches backend route
    method: "PUT",
    data: { status }, // Field name must match what backend expects
  })
  return response.data
}

export {
  newRegistration,
  getAllRegistration,
  updateRegistration,
  deleteRegistration,
  scheduleInterview,
  updateInterviewStatus,
  updateRegistrationStatus,
  getInterviewList,
}
